import { TranslocoMissingHandler } from '@ngneat/transloco';

export class MyMissingTranslationHandler implements TranslocoMissingHandler {
  handle(key: string): any {
    // console.log('Missing translation for ', key);
    return key;
  }
}
